export default __webpack_public_path__ + "static/media/ret_sta_6.e031b633.jpeg";